module.exports = __webpack_public_path__ + "img/ken-liu.92c086dc.png";